import { createNextTableContext } from '@core/table';

export const CustomsTasksTableContext = createNextTableContext();
